import { render } from "./MemberRoles.vue?vue&type=template&id=b48abd44"
import script from "./MemberRoles.vue?vue&type=script&lang=js"
export * from "./MemberRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__